"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC1155TokenReceiver__factory = exports.ERC1155__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ERC1155__factory_1 = require("./ERC1155__factory");
Object.defineProperty(exports, "ERC1155__factory", { enumerable: true, get: function () { return ERC1155__factory_1.ERC1155__factory; } });
var ERC1155TokenReceiver__factory_1 = require("./ERC1155TokenReceiver__factory");
Object.defineProperty(exports, "ERC1155TokenReceiver__factory", { enumerable: true, get: function () { return ERC1155TokenReceiver__factory_1.ERC1155TokenReceiver__factory; } });
//# sourceMappingURL=index.js.map